module.exports = __webpack_public_path__ + "static/media/fungal-nail-test.8e44aa5a.jpeg";